export default "__VITE_ASSET__B_jgUW52__"